import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModules } from '@utils/shared-modules';
import {
  ImageCroppedEvent,
  ImageCropperModule,
  ImageTransform,
} from 'ngx-image-cropper';

@Component({
  selector: 'app-image-crop',
  standalone: true,
  imports: [
    CommonModule,
    ImageCropperModule,
    MatSliderModule,
    FormsModules,
    TranslateModule,
  ],
  templateUrl: './image-crop.dialog.html',
  styleUrl: './image-crop.dialog.scss',
})
export class ImageCropDialog {
  private croppedImageBase64: string = '';

  aspectRatio: number = 4 / 3;
  resizeToWidth: number = 0;
  imageBase64: string = '';

  transform: ImageTransform = {};
  scale = 1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImageCropDialog>,
  ) {
    if (data) {
      this.aspectRatio = data.aspectRatio;
      this.resizeToWidth = data.resizeToWidth;
      this.imageBase64 = data.imageBase64;
    }
  }

  onImageCropped(event: ImageCroppedEvent) {
    if (event.base64) {
      this.croppedImageBase64 = event.base64;
    }
  }

  confirm() {
    this.dialogRef.close({ croppedImageBase64: this.croppedImageBase64 });
  }

  reset() {
    this.scale = 1;
    this.transform = {};
  }

  onZoom(scale: number) {
    this.scale = scale;
    this.transform = {
      ...this.transform,
      scale: scale,
    };
  }

  close() {
    this.dialogRef.close();
  }
}
